import type { Messages } from "./messages/types";

type NestedKeyOf<T, Prefix extends string = ""> = T extends string
	? Prefix extends `${infer _}.${infer _Rest}`
		? never
		: Prefix
	: {
			[K in keyof T & string]: T[K] extends string
				? `${Prefix}${K}`
				: T[K] extends readonly unknown[]
					? `${Prefix}${K}`
					: NestedKeyOf<T[K], `${Prefix}${K}.`>;
		}[keyof T & string];

export type MessageKey = NestedKeyOf<Messages>;

function getNestedValue(obj: unknown, path: string): unknown {
	return path.split(".").reduce<unknown>((current, key) => {
		if (current && typeof current === "object" && key in current) {
			return (current as Record<string, unknown>)[key];
		}
		return undefined;
	}, obj);
}

export function interpolate(template: string, params?: Record<string, string | number>): string {
	if (!params) return template;
	return template.replace(/\{\{(\w+)\}\}/g, (_, key: string) => String(params[key] ?? `{{${key}}}`));
}

export function createTranslator(messages: Messages) {
	return function t(key: MessageKey, params?: Record<string, string | number>): string {
		const value = getNestedValue(messages, key);
		if (typeof value !== "string") {
			return key;
		}
		return interpolate(value, params);
	};
}
